import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import type { ApiKey } from '@partiri-cloud/types';

/**
 * @file apikeys.ts
 * Class for the apikeys for the users and public API
 */
export class ApiKeysApi {
  protected endpoint = '/apikeys'
  
  constructor(private readonly http: HttpClient) { }

  /**
   * Get list of user api keys
   */
  public list(): Observable<ApiKey[]> {
    return this.http.get<ApiKey[]>(this.endpoint)
  }

  /**
   * Generate api keys
   * @param user 
   * @returns 
   */
  public generate(): Observable<ApiKey> {
    return this.http.get<ApiKey>(`${this.endpoint}/generate`)
  }

  /**
   * Create api key for user
   * @param user 
   * @param apiKeyOptions 
   * @returns 
   */
  public create(apiKey: ApiKey): Observable<ApiKey> {
    return this.http.post<ApiKey>(this.endpoint, apiKey)
  }

  /**
   * Delete users api key
   * @param apiKeyId 
   * @returns 
   */
  public delete(apiKeyId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${apiKeyId}`)
  }
}
